import { render, staticRenderFns } from "./skeletonSlider.vue?vue&type=template&id=a8e836ec&scoped=true&"
var script = {}
import style0 from "./skeletonSlider.vue?vue&type=style&index=0&id=a8e836ec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e836ec",
  null
  
)

export default component.exports